// extracted by mini-css-extract-plugin
export default {"appVersion":"General_appVersion__p2iYi"};